module.exports = __webpack_public_path__ + "static/media/download-icon.b057af50.svg";